import React from 'react';
import PropTypes from 'prop-types';
import './Organization.scss';

const rootClass = 'organization';
const contentClass= `${rootClass}__content`;
const contentList = `${contentClass}__list`

const OrganizationListItem = ({ organization }) => {
	const { name, title, duration: { from, to }, isCurrent } = organization;
	return (
		<div className={contentList}>
			<div className={`${contentList}__name`}>{name}</div>
			<div className={`${contentList}__role`}>{title}</div>
			<div className={`${contentList}__duration`}>
				{`${from.month} ${from.year} - ${isCurrent ? 'till now': `${to.month} ${to.year}`}`}
			</div>
		</div>
	);
}


const Organization = ({ organizations }) => {
	const organizationList = organizations.map((organization, idx) => 
		<OrganizationListItem organization={organization} key={idx} />
	);

	return (
		<div className={rootClass}>
			<h3 className={`${rootClass}__title`}>
				Organization
			</h3>
			<div className={contentClass}>
				{organizationList}
			</div>
		</div>
	);
};

Organization.propTypes = {
	organizations: PropTypes.array,
};

export default Organization;